(() => {
    const SELECT_WRAPPER = '.po-select-root';
    const SELECTED_VALUE = '.po-select-selectedValue';
    const OPTION_LABEL = '.po-optionItemLabel-label';
    const LIST_ITEM = '.po-select-listItem';

    const SPECIAL_OPTIONS = ['Hebrew Phrase', 'Symbol'];

    function getDropdowns() {
        return [...document.querySelectorAll(SELECT_WRAPPER)];
    }

    function getSelectedValue(dropdown) {
        const el = dropdown.querySelector(SELECTED_VALUE);
        return el ? el.textContent.trim() : '';
    }

    function getOwners() {
        const owners = {};

        getDropdowns().forEach(dropdown => {
            const value = getSelectedValue(dropdown);

            if (SPECIAL_OPTIONS.includes(value)) {
                owners[value] = dropdown;
            }
        });

        return owners;
    }

    function refreshDropdownOptions() {
        const owners = getOwners();

        document.querySelectorAll(`${SELECT_WRAPPER} .po-select-list`).forEach(list => {

            const currentDropdown = list.closest(SELECT_WRAPPER);

            list.querySelectorAll(LIST_ITEM).forEach(item => {

                const label = item.querySelector(OPTION_LABEL);

                if (!label) return;

                const text = label.textContent.trim();

                if (!SPECIAL_OPTIONS.includes(text)) {
                    item.style.display = '';
                    return;
                }

                const owner = owners[text];

                if (!owner) {
                    item.style.display = '';
                    return;
                }

                if (owner === currentDropdown) {
                    item.style.display = '';
                } else {
                    item.style.display = 'none';
                }
            });
        });
    }

    function observeSelections() {

        getDropdowns().forEach(dropdown => {

            if (dropdown.dataset.specialObserver)
                return;

            dropdown.dataset.specialObserver = '1';

            const selected = dropdown.querySelector(SELECTED_VALUE);

            if (!selected)
                return;

            new MutationObserver(() => {

                // allow Easify to finish rendering
                
                setTimeout(() => {

                refreshDropdownOptions();

                const value = getSelectedValue(dropdown);

                if (value === 'Hebrew Phrase') {

                    const field = dropdown.closest('.po-field-root');
                    if (!field) return;

                    // Find the next "Select a Phrase" field
                    const phraseField = [...document.querySelectorAll('.po-field-root')]
                        .find(f => {
                            const label = f.querySelector('.po-label-label');
                            return label && label.textContent.trim() === 'Select a Phrase';
                        });

                    if (!phraseField) return;

                    const button = phraseField.querySelector('.po-select-button');

                    if (button && button.getAttribute('aria-expanded') !== 'true') {
                        button.click();
                    }

                }

            }, 10);

            }).observe(selected, {
                childList: true,
                subtree: true,
                characterData: true
            });
        });
    }

    function observeNewDropdowns() {

        new MutationObserver(() => {

            observeSelections();

            setTimeout(refreshDropdownOptions, 10);

        }).observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    observeSelections();
    observeNewDropdowns();
    refreshDropdownOptions();

})();